

















































































/** @format */

import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import { DEFAULT_DATE_FORMAT } from '@root/common/config';
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';
import { BUSINESS_LIST } from '../router-names';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
// axios请求
import { statRecordetail, editMerchant } from '@/api/discount-management/index';
import { IFieldInfoListItem } from '@root/types/component';
import BusinessInformation from './components/business-information.vue';
import PackagePurchaseRecord from './components/package-purchase-record.vue';
import VoucherIssuanceRecord from './components/voucher-issuance-record.vue';
// import FieldInfoList from '@root/frame/src/components/field-info-list/index.vue'
import { isShiDaisy } from '@root/utils/env';
@Component({
  components: { BusinessInformation, PackagePurchaseRecord, VoucherIssuanceRecord }
})
export default class BusinessDetail extends Mixins(GoBackWithCloseTabMixin, TableMixin, TableWidthMixin) {
  path = '/smart-parking/parking-lot-management/device-list/';

  deviceId = '';
  detailList = {};
  headTitle = '商家详情';
  headertitle = '';
  detailModel: any = {};
  id: any = '';
  activeKey: string = '1';
  singleCouponMaxMoney: string = '';
  singleCouponMaxTime: string = '';
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '商家管理',
        location: {
          name: BUSINESS_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }

  deviceListForm: IFieldInfoListItem[] = [
    {
      prop: 'typeDesc',
      label: '设备类型 ：'
    },
    {
      prop: 'parkName',
      label: '所属车场 ：'
    },
    {
      prop: 'brandDesc',
      label: '设备品牌 ：'
    },
    {
      prop: 'ip',
      label: '设备IP ：'
    },
    {
      prop: 'port',
      label: '设备端口 ：'
    },
    {
      prop: 'connectTypeDesc',
      label: '设备连接方式 ：'
    },
    {
      prop: 'connectSourceDesc',
      label: '设备连接源 ：'
    },
    {
      prop: 'deviceVersionDesc',
      label: '驱动版本 ：'
    },
    {
      prop: 'priority',
      label: '优先级 ：'
    },

    {
      prop: 'statusDesc',
      label: '设备状态 ：'
    },
    {
      prop: 'isSupportTtsDesc',
      label: '是否支持万能语音 ：'
    },
    {
      prop: 'deviceCode',
      label: '设备编号 ：'
    }
  ];
  couponPriceShow: boolean = true;
  couponTimeShow: boolean = true;
  get typePriceIcon() {
    return this.couponPriceShow ? 'form' : 'check-square';
  }
  get typeTimeIcon() {
    return this.couponTimeShow ? 'form' : 'check-square';
  }
  isShiDaisy: boolean = true;
  timeFlag: boolean = false;
  priceFlag: boolean = false;
  created() {
    this.id = this.$route.params.id;
    this.activeKey = this.$route.params.activeKey ? this.$route.params.activeKey : '1';
    // this.deviceId = this.$route.params.deviceId
    // this.renderDetail(this.$route.params.deviceId)
    this.getstatRecordetail();
  }

  activated() {
    console.log('走这里了？？？');
    if (!this.id) {
      this.id = this.$route.params.id;
      this.activeKey = this.$route.params.activeKey ? this.$route.params.activeKey : '1';
      this.getstatRecordetail();
    }
  }
  getAllDetailList: any = {};
  async getstatRecordetail() {
    try {
      const { data } = await statRecordetail({ id: this.id });
      this.getAllDetailList = data;
      const { singleCouponMaxTime = '', singleCouponMaxMoney = '' } = data;
      this.singleCouponMaxTime = singleCouponMaxTime;
      this.singleCouponMaxMoney = singleCouponMaxMoney;
    } catch (e) {
      console.log(e);
    }
  }
  //   async renderDetail(deviceId: string) {
  // try {
  //   const { status, msg, code, data } = await editInfoDeviceList({ deviceId })
  //   if (status === '9999') {
  //     this.detailList = data
  //     this.headertitle = data.name
  //   }
  //   // console.log(status, msg, code, data)
  //   // this.detailList = datas
  // } catch (error) {
  //   console.log(error)
  // }
  //   }
  // // 返回
  // goBack() {
  //   this.$router.replace({
  //     name: DEVICE_LIST,
  //   })
  // }
  callback(key) {
    console.log(key);
  }
  //编辑单张优惠券最大额度
  async editMaxCoupon(val, type) {
    const json = {
      singleCouponMaxTime: type == 1 ? val : null,
      singleCouponMaxMoney: type == 2 ? val : null,
      id: this.id
    };
    try {
      const data = await editMerchant(json);
      if (type == 1) {
        this.couponTimeShow = true;
      } else {
        this.couponPriceShow = true;
      }
      this.getstatRecordetail();
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统异常，请稍后再试');
    }
  }
  editCoupon(type: number) {
    if (type == 1) {
      if (this.couponTimeShow) return (this.couponTimeShow = false);
      if (!this.couponTimeShow) {
        if (this.timeFlag) return;
        if (!this.singleCouponMaxTime) return this.$message.error('请输入单张优惠券最大优惠额度');
        if (
          !/^((0{1}\.\d{1})|([1-9]\d*\.{1}\d{1})|([1-9]+\d*)|0)$/.test(this.singleCouponMaxTime) ||
          !(Number(this.singleCouponMaxTime) < 100000)
        )
          return this.$message.error('单张优惠券最大优惠额度格式不正确,请输入数字,最大不超过五位，支持一位小数');

        this.editMaxCoupon(this.singleCouponMaxTime, 1);
      }
    }
    if (type == 2) {
      if (this.couponPriceShow) return (this.couponPriceShow = false);
      if (!this.couponPriceShow) {
        console.log('编辑');
        if (this.priceFlag) return;
        if (!this.singleCouponMaxMoney) return this.$message.error('请输入单张优惠券最大优惠额度');
        if (
          !/^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*)|0)$/.test(this.singleCouponMaxMoney) ||
          !(Number(this.singleCouponMaxMoney) < 100000)
        )
          return this.$message.error('单张优惠券最大优惠额度格式不正确,请输入数字,最大不超过五位，支持两位小数');
        this.editMaxCoupon(this.singleCouponMaxMoney, 2);
      }
    }
  }
}
